const { USER_EMAIL_NOT_EXIST } = require('./codes/errorCodes');

/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    [USER_EMAIL_NOT_EXIST.code]: {
        code: 'USER_EMAIL_NOT_EXIST',
        description: 'User with requested email does not exist.',
    },
    API_IS_UNAVAILABLE_500: {
        code: 'API_IS_UNAVAILABLE',
        description: 'API is currently down.',
    },
    REGISTRATION_CONFIRMATION_TOKEN_ALREADY_USED: {
        code: 'REGISTRATION_CONFIRMATION_TOKEN_ALREADY_USED',
        description: 'User has alredy confirmed a registration email.',
    },
    RESET_PASSWORD_CONFIRMATION_TOKEN_EXPIRED: {
        code: 'RESET_PASSWORD_CONFIRMATION_TOKEN_EXPIRED',
        description: 'Reset password confirmation token has expired.',
    },
    REGISTRATION_CONFIRMATION_TOKEN_EXPIRED: {
        code: 'REGISTRATION_CONFIRMATION_TOKEN_EXPIRED',
        description: 'Registration confirmation token has expired.',
    },
    RESERVATION_CAPACITY_FULL: {
        code: 'RESERVATION_CAPACITY_FULL',
        description: 'Reservation capacity is full, somebody was probably faster.',
    },
    NOT_ENOUGH_EMPTY_SLOTS: {
        code: 'NOT_ENOUGH_EMPTY_SLOTS',
        description:
            'Reservation capacity is not full, but requested more reservations than empty slots to full capcity.',
    },
    USER_ALREADY_REGISTERED: {
        code: 'USER_ALREADY_REGISTERED',
        description: 'User is already registered, must be logged in to do reservation.',
    },
    INSUFFICIENT_CREDIT_BALANCE: {
        code: 'INSUFFICIENT_CREDIT_BALANCE',
        description: "Client doesn't have sufficient credit balance.",
    },
    EXPIRED_CREDIT_BALANCE: {
        code: 'EXPIRED_CREDIT_BALANCE',
        description: 'Credit balance expired.',
    },
    INSUFFICIENT_PASS_BALANCE: {
        code: 'INSUFFICIENT_PASS_BALANCE',
        description: "Client doesn't have sufficient pass balance.",
    },
    INSUFFICIENT_MAKE_UP_SESSION_BALANCE: {
        code: 'INSUFFICIENT_MAKE_UP_SESSION_BALANCE',
        description: "Client doesn't have sufficient makeup session balance.",
    },
    EXPIRED_PASS_BALANCE: {
        code: 'EXPIRED_PASS_BALANCE',
        description: 'Pass balance expired.',
    },
    STRIPE_ERROR: {
        code: 'STRIPE_ERROR',
        description: `Stripe threw some error. It is not possible to pay by card now.`,
    },
    ORIGINAL_PASSWORD_DOES_NOT_MATCH: {
        code: 'ORIGINAL_PASSWORD_DOES_NOT_MATCH',
        description: 'User entered wrong password.',
    },
    SMARTEMAILING_INVALID_CREDENTIALS: {
        code: 'SMARTEMAILING_INVALID_CREDENTIALS',
        description: 'Invalid smartemailing credentials.',
    },
    MAILERLITE_INVALID_CREDENTIALS: {
        code: 'MAILERLITE_INVALID_CREDENTIALS',
        description: 'Invalid MailerLite credentials.',
    },
    ECOMAIL_INVALID_CREDENTIALS: {
        code: 'ECOMAIL_INVALID_CREDENTIALS',
        description: 'Invalid ecomail credentials.',
    },
    ECOMAIL_IS_DOWN: {
        code: 'ECOMAIL_IS_DOWN',
        description: 'Ecomail is down.',
    },
    MAILCHIMP_INVALID_CREDENTIALS: {
        code: 'MAILCHIMP_INVALID_CREDENTIALS',
        description: 'Invalid mailchimp credentials.',
    },
    MORE_LECTURE_RESERVATIONS_NOT_ALLOWED: {
        code: 'MORE_LECTURE_RESERVATIONS_NOT_ALLOWED',
        description: 'It is not possible to create multiple reservations connected with one email',
    },
    ZENAMU_DOMAIN_INVALID_URL: {
        code: 'ZENAMU_DOMAIN_INVALID_URL',
        description: 'Invalid zenamu slug.',
    },
};
